var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    class: [_vm.$style.card, _vm.$style['content-center']],
    on: {
      "click": function click($event) {
        return _vm.$emit('click');
      }
    }
  }, [_c('div', {
    class: _vm.$style.icon
  }), _c('div', {
    class: _vm.$style.label
  }, [_vm._v(_vm._s(_vm.$t('new.target')))])]);
}
var staticRenderFns = []

export { render, staticRenderFns }